<template>
  <div class="backlogin">
    <v-container>
      <v-row>
        <v-col>
          <LoginComponent></LoginComponent>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import LoginComponent from "@/components/LoginComponent.vue";

export default {
  name: "LoginView",
  components: {
    LoginComponent,
  },
};
</script>
<style >
.backlogin{
  width: 100%;
  height: 100%;

  
  background-size: cover;



}
body{
  background-color: #ffffff;
}
</style>
